// Anglar
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Layout Directives
// Services
import {
	ContentAnimateDirective,
	FirstLetterPipe,
	GetObjectPipe,
	HeaderDirective,
	JoinPipe,
	MenuDirective,
	OffcanvasDirective,
	SafePipe,
	ScrollTopDirective,
	SparklineChartDirective,
	StickyDirective,
	TabClickEventDirective,
	TimeElapsedPipe,
	ToggleDirective,
	UserHasPermissionPipe,
} from './_base/layout';
import { SentDatePipe } from './_base/layout/pipes/sent-date.pipe';
import { TrimPipe } from './_base/layout/pipes/trim.pipe';
import { StringFormatPipe } from './_base/layout/pipes/string-format.pipe';

@NgModule({
	imports: [CommonModule],
	declarations: [
		// directives
		ScrollTopDirective,
		HeaderDirective,
		OffcanvasDirective,
		ToggleDirective,
		MenuDirective,
		TabClickEventDirective,
		SparklineChartDirective,
		ContentAnimateDirective,
		StickyDirective,
		// pipes
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		SafePipe,
		// FirstLetterPipe,
		// SentDatePipe,
		TrimPipe,
		StringFormatPipe,
		UserHasPermissionPipe,
	],
	exports: [
		// directives
		ScrollTopDirective,
		HeaderDirective,
		OffcanvasDirective,
		ToggleDirective,
		MenuDirective,
		TabClickEventDirective,
		SparklineChartDirective,
		ContentAnimateDirective,
		StickyDirective,
		// pipes
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		SafePipe,
		// FirstLetterPipe,
		// SentDatePipe,
		TrimPipe,
		StringFormatPipe,
		UserHasPermissionPipe,
	],
	providers: []
})
export class CoreModule {
}
